import {
    FaMoneyBillWave,
    FaClinicMedical,
    FaChartPie,
    FaChartLine
} from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import IndicatorsWrapper from './Indicators';
import TotalWrapper from './Total';
import ChartsContainer from '../../Common/ChartsContainer';
import FederalFinancingTotalsWrapper from './FederalFinancingTotals';
import ManagementTotalsWrapper from './ManagementTotals';

const menus = [
    {
        title: 'Financiamento',
        path: '/governanceroom/dashboardsihsus/revenue/financing',
        icon: <FaMoneyBillWave />
    },
    {
        title: 'Federal',
        path: '/governanceroom/dashboardsihsus/revenue/federal',
        icon: <FaClinicMedical />
    },
    {
        title: 'Gestão',
        path: '/governanceroom/dashboardsihsus/revenue/management',
        icon: <FaClinicMedical />
    },
    {
        title: 'Total',
        path: '/governanceroom/dashboardsihsus/revenue/total',
        icon: <FaChartPie />
    },
    {
        title: 'Indicadores',
        path: '/governanceroom/dashboardsihsus/revenue/indicators',
        icon: <FaChartLine />
    }
];

const titlesMap = {
    '/governanceroom/dashboardsihsus/revenue/financing':
        'Tipo de Financiamento',
    '/governanceroom/dashboardsihsus/revenue/federal':
        'Valores de Financiamento Federal',
    '/governanceroom/dashboardsihsus/revenue/management':
        'Valores de Financiamento da Gestão',
    '/governanceroom/dashboardsihsus/revenue/indicators':
        'Indicadores de Faturamento',
    '/governanceroom/dashboardsihsus/revenue/total': 'Total'
};

export const Revenue = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsihsus');
    };

    return (
        <div>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titlesMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="financing"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'do Tipo de Financiamento'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.FINANCING_TYPE,
                                        url: 'governanceroom/dashboard/sihsus/aih/finance'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route
                            path="federal"
                            element={<FederalFinancingTotalsWrapper />}
                        />

                        <Route
                            path="management"
                            element={<ManagementTotalsWrapper />}
                        />

                        <Route
                            path="indicators"
                            element={<IndicatorsWrapper />}
                        />

                        <Route path="total" element={<TotalWrapper />} />

                        <Route
                            path="/"
                            element={<Navigate to="financing" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
